<template>
  <div id="app">
    <nav
      class="navbar is-primary"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-brand">
        <router-link class="navbar-item" :to="'/'">
          <img src="logo_canvas.png" />
        </router-link>
        <a
          role="button"
          :class="'navbar-burger burger ' + active"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
          @click="toggle = !toggle"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarBasicExample" :class="'navbar-menu ' + active">
        <div class="navbar-start">
          <a class="navbar-item">
            Home
          </a>

          <a class="navbar-item">
            Documentation
          </a>

          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">
              More
            </a>

            <div class="navbar-dropdown">
              <a class="navbar-item">
                About
              </a>
              <a class="navbar-item">
                Jobs
              </a>
              <a class="navbar-item">
                Contact
              </a>
              <hr class="navbar-divider" />
              <a class="navbar-item">
                Report an issue
              </a>
            </div>
          </div>
        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <a
              href="https://phuctk93.github.io/#contact"
              class="button is-danger"
            >
              <b-icon icon="account" size="is-medium"></b-icon>
              <span>Contact</span>
            </a>
          </div>
        </div>
      </div>
    </nav>
    <router-view />
    <footer class="footer has-text-centered">
      <p>
        <a href="https://canvas-3cbbd.web.app"><b>Canvas</b></a> by
        <a href="https://phuctk93.github.io"><b>phuctk93</b></a
        >.
      </p>
      <p>
        Build with <a href="https://bulma.io"><b>Bulma</b></a
        >, <a href="https://buefy.org/"><b>Buefy</b></a> and
        <a href="https://bulma.io"><b>Vue</b></a
        >.
      </p>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      toggle: false
    };
  },
  computed: {
    active: function() {
      return this.toggle ? "is-active" : "";
    }
  }
};
</script>
